<template>
	<div class="flex flex-col px-4 pb-10 pt-8">
		<div class="flex w-full max-w-screen-xl flex-col self-center">
			<div class="mb-6 flex items-center">
				<span class="flex-grow text-2xl font-bold text-slate-950">
					{{ $t("most_viewed_articles") }}
				</span>
				<span
					class="text-white cursor-pointer rounded-md border-2 border-slate-950 bg-slate-950 px-[15px] py-[9px] font-bold duration-300 hover:bg-white hover:text-slate-950"
					@click="() => emit('goToAll')"
				>
					{{ $t("all_articles") }}
				</span>
			</div>
			<div v-if="articles?.length" class="grid grid-cols-1 gap-6 lg:grid-cols-12">
				<div class="grid gap-6 lg:col-span-8">
					<NuxtLink
						v-if="articles?.[0]"
						:to="$routeUrl.BlogArticleUrl(articles?.[0]?.id)"
						class="flex flex-col"
					>
						<ArticleCard
							:article="articles?.[0]"
							mode="v"
							size="lg"
							hide-footer
							disable-hover
							image-container-class="lg:!aspect-[2/1]"
							color="#ffb300"
							class="flex-grow"
						/>
					</NuxtLink>
				</div>
				<div class="grid gap-6 lg:col-span-4">
					<NuxtLink
						v-if="articles?.[1]"
						class="flex min-h-[160px] flex-col"
						:to="$routeUrl.BlogArticleUrl(articles?.[1]?.id)"
					>
						<ArticleCard
							:article="articles?.[1]"
							:mode="articles.length > 2 ? 'h' : 'v'"
							size="sm"
							hide-footer
							disable-hover
							color="#d81b60"
							class="flex-grow"
						/>
					</NuxtLink>
					<div v-else class="bg-slate-200 relative flex-grow overflow-hidden rounded-lg shadow-inner">
						<div class="absolute bottom-0 left-0 right-0 top-0 bg-[#d81b60]/25"></div>
					</div>
					<NuxtLink
						v-if="articles?.[2]"
						class="flex min-h-[160px] flex-col"
						:to="$routeUrl.BlogArticleUrl(articles?.[2]?.id)"
					>
						<ArticleCard
							:article="articles?.[2]"
							mode="h"
							size="sm"
							hide-footer
							disable-hover
							color="#00897b"
							class="flex-grow"
						/>
					</NuxtLink>
					<NuxtLink
						v-if="articles?.[3]"
						class="flex min-h-[160px] flex-col"
						:to="$routeUrl.BlogArticleUrl(articles?.[3]?.id)"
					>
						<ArticleCard
							:article="articles?.[3]"
							mode="h"
							size="sm"
							hide-footer
							disable-hover
							color="#1e88e5"
							class="flex-grow"
						/>
					</NuxtLink>
				</div>
			</div>
			<div v-if="!articles?.length" class="bg-white border-slate-300 flex flex-col rounded-lg border py-6">
				<BaseEmptyBox class="w-full max-w-lg self-center" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Post } from "~/models/post"

const emit = defineEmits<{
	goToAll: []
}>()

defineProps<{
	articles?: Post[]
}>()
</script>
